import { AnsweredQuestionWithId, DropdownOption } from "../questionnaires/model";

export const EMPLOYEE_SATISFACTION_SURVEY_KEY = "EMPLOYEE_SATISFACTION_SURVEY_KEY";

export interface EmployeeSatisfactionSurveyModel {
    questions: AnsweredQuestionWithId[];
    eTag: string;
}

export interface EmployeeSatisfactionSurveyDto {
    isExpired: boolean;
    isCompleted: boolean;
    customerId: string;
    ohCaseId: string;
    taskId: string;
}

export enum AgreementLevel {
    StronglyAgree = "StronglyAgree",
    Agree = "Agree",
    SomewhatAgree = "SomewhatAgree",
    SomewhatDisagree = "SomewhatDisagree",
    Disagree = "Disagree",
    StronglyDisagree = "StronglyDisagree"
}

export const agreementLevelOptions: DropdownOption[] = [
    { text: "Strongly Agree", value: AgreementLevel.StronglyAgree, order: 1 },
    { text: "Agree", value: AgreementLevel.Agree, order: 2 },
    { text: "Somewhat Agree", value: AgreementLevel.SomewhatAgree, order: 3 },
    { text: "Somewhat Disagree", value: AgreementLevel.SomewhatDisagree, order: 4 },
    { text: "Disagree", value: AgreementLevel.Disagree, order: 5 },
    { text: "Strongly Disagree", value: AgreementLevel.StronglyDisagree, order: 6 }
];

enum Applicability {
    NotApplicableNoReportWasIssued = "NotApplicableNoReportWasIssued"
}

const ApplicabilityAndAgreementLevel = { ...AgreementLevel, ...Applicability };

export const applicabilityAndAgreementLevelOptions: DropdownOption[] = [
    { text: "Not Applicable – No report was issued", value: ApplicabilityAndAgreementLevel.NotApplicableNoReportWasIssued, order: 1 },
    { text: "Strongly Agree", value: ApplicabilityAndAgreementLevel.StronglyAgree, order: 2 },
    { text: "Agree", value: ApplicabilityAndAgreementLevel.Agree, order: 3 },
    { text: "Somewhat Agree", value: ApplicabilityAndAgreementLevel.SomewhatAgree, order: 4 },
    { text: "Somewhat Disagree", value: ApplicabilityAndAgreementLevel.SomewhatDisagree, order: 5 },
    { text: "Disagree", value: ApplicabilityAndAgreementLevel.Disagree, order: 6 },
    { text: "Strongly Disagree", value: ApplicabilityAndAgreementLevel.StronglyDisagree, order: 7 }
];
